<div class="page-wraper" appSpin [spinnerConfig]='spinnerConfig()'>
    <div class="page-title-block bg-transparent pb-0" [ngClass]="{ 'my-custom-class': exportCustomData() }">
        <h1 class="h3">Export Data</h1>
    </div>
    <div class="content-block-main pt-4 common-head export-tab">
        @if(!exportCustomData()){
            <mat-tab-group class=" h-100" [selectedIndex]="selectedTab"
                (selectedIndexChange)="onTabChange($event)">
                <mat-tab label="Export Data">
                    @if(!exportAllData()){
                    <div class="no-data-found w-400">
                        <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                        <h4>Choose from below options</h4>
                        <p class="text-gray-6">
                            Export all your firm's data at once or select specific clients for export
                        </p>
                        <div class="button-group mt-3">
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                (click)="openExportAllDataPopup()">
                                <i class="fa-regular fa-file-export"></i>
                                Export All</button>
                            <button mat-button mat-stroked-button color="dark" class="button-default"
                                (click)="exportCustomData.set(true);$event.stopPropagation()"><i class="fa-regular fa-file-export"></i>Export Customized</button>
                        </div>
                    </div>
                }

                    @if(exportAllData()){
                        <app-user-export-all-data class="flexbox-column h-100"
                                                  [clientCount]="clientCount$ |async"
                                                  [engCount]="engagementCount$ | async"
                                                  (goBack)="goBackToExportData()"
                        ></app-user-export-all-data>
                    }
                </mat-tab>
                <mat-tab label="Export History {{(inProgressCount) ? inProgressCount : ''}}">
                    <ng-container>
                        <app-user-export-history class="flexbox-column h-100"></app-user-export-history>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        }

        @if(exportCustomData()){
            <app-custom-data-export class="flexbox-column h-100 gap-5"
                (goBack)="goBackToExportData()"></app-custom-data-export>
        }
    </div>
</div>



<!--Export all data popup-->
<ng-template #exportAllDataDailog>
    <div class="countable-dialog confirmation-dailog">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-warning badge-circle icon-bordered-warning text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title">Export All Data</h4>
            <button mat-button class="close" [mat-dialog-close] (click)="dialogRef.close()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center px-2">
            <p class="text-error fw-semibold">
                Note: You are exporting data for {{ clientCount$ | async }} clients and {{ engagementCount$ | async }}
                engagements.
            </p>
            <p>Are you sure you want to proceed ?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]
                (click)="dialogRef.close()">Cancel</button>
            <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]
                (click)="proceedWithExportAll()">Proceed</button>
        </div>
    </div>
</ng-template>
